import { FC, ReactNode, useState } from 'react';
import { Box, IconButton } from '@mui/joy';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from 'Components/Sidebar';
import LogoHeader from './Header';
import UploadProgressSnackbar from './UploadProgressSnackbar';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

interface Props {
  children: ReactNode;
}

const MainLayout: FC<Props> = ({ children }) => {
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <div>
      <LogoHeader />
      <Box
        sx={{ display: 'flex', minHeight: 'calc(100vh - 48px)', width: '100%' }}
      >
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <Box component="main" className="MainContent p-2">
          {!isHomePage && (
            <IconButton
              variant="outlined"
              color="neutral"
              size="sm"
              onClick={() => setSidebarOpen(true)}
              aria-label={t('Open navigation menu')}
              sx={{
                display: { xs: 'inline-flex', md: 'none' },
                alignSelf: 'flex-start',
                mb: 1,
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          {children}
        </Box>
      </Box>

      <UploadProgressSnackbar />
    </div>
  );
};

export default MainLayout;
